import React from 'react';
import { TStepLegsOption, TStepRangesOption, TStepsOption } from '../../../api/endpoints/SubsetOption';
import StepOptionsControl from './StepOptionsControl';
import StepWithLegsControl from './StepWithLegsControl';
import StepRangesControl from './StepRangesControl';

export const specToStepsType = (spec: TStepLegsOption | TStepsOption | TStepRangesOption) => {
  if ('legs' in spec.value) {
    return 'legs';
  }

  if ('step' in spec.value) {
    if (typeof spec.value.step[0] === 'string') {
      return 'ranges';
    }

    return 'options';
  }

  return 'unknown';
};

const ForecastStepsSelector = (props: {
  values: Array<string>;
  spec: TStepLegsOption | TStepsOption | TStepRangesOption;
  onChange: (values: Array<string>) => void;
}) => {
  const { spec, values, onChange } = props;

  const stepsType = specToStepsType(spec);

  switch (stepsType) {
    case 'legs':
      return <StepWithLegsControl spec={spec as TStepLegsOption} values={values} onChange={onChange} />;
    case 'ranges':
      return <StepRangesControl spec={spec as TStepRangesOption} values={values} onChange={onChange} />;
    case 'options':
      return <StepOptionsControl spec={spec as TStepsOption} values={values} onChange={onChange} />;
    default:
      return null;
  }
};

export default ForecastStepsSelector;
